(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.directive('agendaAppointmentAdditionalInfo', [ AgendaAppointmentAdditionalInfoFn]);

    /* display an additional info in agenda-appointment */
    function AgendaAppointmentAdditionalInfoFn() {

        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-appointment-additional-info.template.html',
            scope: {
                info: '=', 
                infos: '='
            }
        };
        return directive;

        function link(scope, element) {
            element.find('#caption').focus();
           
            activate();

            /* do activation work */
            function activate() {
            }

            // delete
            scope.delete = function () {
                if (typeof scope.infos === 'undefined') { return; }
                // delete item from array
                scope.infos.splice(scope.infos.indexOf(scope.info), 1);
            };
            
        }
    }

})();